import { Element, Node } from 'slate';
import { RenderElementProps } from 'slate-react';
import { CustomEditor, CustomElement, MentionElement } from 'slate/types/slate';
import { Mention } from './components/Mention';

const isMention = (node: Node): node is MentionElement => Element.isElement(node) && node.type === 'mention';

const withMentions = (editor: CustomEditor) => {
  const { isInline, isVoid, renderElement } = editor;

  editor.isInline = (element: CustomElement) => isMention(element) || isInline(element);
  editor.isVoid = (element: CustomElement) => isMention(element) || isVoid(element);

  editor.renderElement = (props: RenderElementProps) => {
    if (isMention(props.element)) {
      return <Mention {...props} />;
    } else {
      return renderElement(props);
    }
  };

  return editor;
};

export default withMentions;
